// Hotfix: only for Brasil schools - re-enrolment always refers to the next academic year
export const getReEnrolmentYear = () => new Date().getFullYear() + 1;
